var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('HomepageLandingLayout',{attrs:{"keywords":_vm.keywords,"description":_vm.description}},[_c('LandingPageHero',{attrs:{"headline":_vm.headline,"subtitle":_vm.subtitle}}),_vm._v(" "),_c('LandingPageSaveTime'),_vm._v(" "),_c('LandingPagePortal'),_vm._v(" "),_c('Testimonial'),_vm._v(" "),_c('Demo')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-04203237","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/homepage/LandingPage.vue
// module id = UpSE
// module chunks = 1